/**
 * Ryan O'Dowd
 * 2021-05-28
 * © Copyright 2021 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, badgeSize}) => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    image: {
      display: 'flex',
      width: '100%',
      height: '100%',
      aspectRatio: 1,
      borderRadius: globalScale * 16,
      borderColor: colors.primaryLight, // @TODO: different if premium?
      borderWidth: 4,
    },
    imageLoadingIndicator: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    viewerFooter: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 10,
      paddingBottom: 20,
    },
    displayNameText: {
      color: colors.dialogText,
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      textAlign: 'center',
    },
    usernameText: {
      color: colors.dialogText,
      fontSize: globalScale * 14,
      fontFamily: fonts.secondaryItalic,
      textAlign: 'center',
    },
    foo: {
      width: 56,
    },
    recentlyActiveBadge: { // @TODO: would be cool to make this pulsate (really slowly)
      position: 'absolute',
      bottom: -2,
      right: -2,
      width: badgeSize,
      height: badgeSize,
      borderRadius: badgeSize / 2,
      backgroundColor: colors.accent,
      borderColor: colors.primaryLight,
      borderWidth: 2,
    },
  };
};

export default getStyles;
